<template>
	<div id="app">
		<router-view />
	</div>
</template>

<script>
export default {
	name: 'App',
	mounted() {
		let this_url = location.href
		console.log('app this_url', this_url)
		if (this_url.indexOf('/sso') > -1 && this_url.indexOf('#/sso') < 0 && this_url.indexOf('#/') > 0) {
			console.log('redirect to sso')
			this_url = this_url.replace('#', '')
			this_url = this_url.replace('/sso', '/#/sso')
			window.location.href = this_url
		}
		if (this_url.indexOf('/commsso') > -1 && this_url.indexOf('#/commsso') < 0) {
			console.log('redirect to commsso')
			this_url = this_url.replace('#', '')
			this_url = this_url.replace('/commsso', '/#/commsso')
			window.location.href = this_url
		}
	},
	created() {}
}
</script>

<style lang="scss">
@import './assets/style/base.scss';
</style>
